import { muiStyles } from 'utils/design';

export const useStyles = muiStyles({
  tooltipIcon: {
    position: 'absolute',
    right: '-10px',
    top: '10px',
  },
});
